import moment from 'moment';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import {
  fetchAvailableAdvisors as fetchAvailableAdvisorsRequester,
  fetchAvailableHoursAdvisorRequester,
  fetchAvailableHours as fetchAvailableHoursRequester,
  fetchEmptyDatesRequester
} from '../../../requesters/advisors';

import {
  APPOINTMENT_DATE_SELECTED,
  APPOINTMENT_SCHEDULE_RANGE_SELECTED,
  APPOINTMENT_DATA_ERROR,
  STORE_APPOINTMENT_DATA_SUCCESS,
  CLEAN_APPOINTMENT_STORE,
  STORE_ADDRESS_FORM_VALUES_SUCCESS,
  GEOLOCATE_ADDRESS_SUCCESS,
  GET_ADVISORS_HOURS_SUCCESS,
  GET_ADVISORS_SUCCESS,
  CLEAN_ADVISOR_STORE,
  STORE_WORKSHOP_LATLNG,
  SET_SELECTED_DATE_AND_TIME,
  SET_BEFORE_BUDGET,
  STORE_PICKUP_ADDRESS,
  PERSIST_DATEPICKERUI_VALUES,
  GET_EMPTY_DATES_SUCCESS
} from './types';
import validation from '../../../constants/validation';

import { apiErrorHandler } from '../../../errors';

import { SATURDAY, SUNDAY } from '../../../constants/weekDays'

const { PAST_DATE } = validation;

export function selectNewDate(newDate) {
  return (dispatch) => {
    const _currentDate = new Date();
    const currentDate = moment({
      year: _currentDate.getFullYear(),
      month: _currentDate.getMonth(),
      day: _currentDate.getDate()
    });

    //Set time to 00:00:00:00
    currentDate.startOf('day');
    const selectedDate = moment(newDate).startOf('day');

    if (currentDate.isoWeekday() === SATURDAY) { // it was 5 instead of SATURDAY with laboral day restriction
      currentDate.add(2, 'days'); // it was 4 days with laboral day restricton
    } else if (currentDate.isoWeekday() === SUNDAY) { // it was 6 instead of SUNDAY with laboral day restriction
      currentDate.add(1, 'days'); // it was 3 days with laboral day restriction
    } else {
      // Add 2 days to the currentdate
      /**
       * NOTE: COMMENTED BECAUSE THERE IS NO MORE "2 LABORAL DAYS RESTRICTION"
       */
      // currentDate.add(2, 'days');
    }

    if (selectedDate.isBefore(currentDate)) {
      dispatch({
        type: APPOINTMENT_DATA_ERROR,
        payload: {
          error: {
            // date: 'La cita debe pedirse con dos días laborables de antelación.'
            date: 'La cita debe ser al menos el día actual.'
          },
          date: newDate
        }
      })
    } else if (selectedDate.isoWeekday() === SATURDAY || selectedDate.isoWeekday() === SUNDAY) {
      dispatch({
        type: APPOINTMENT_DATA_ERROR,
        payload: {
          error: {
            date: 'La cita no puede ser en Sábado ni Domingo.'
          },
          date: newDate
        }
      })
    } else {
      dispatch({
        type: APPOINTMENT_DATE_SELECTED,
        payload: {
          newDate,
        },
      });
    }
  };
}

export function selectScheduleRange(newRange) {
  return (dispatch) => {
    dispatch({
      type: APPOINTMENT_SCHEDULE_RANGE_SELECTED,
      payload: {
        newRange,
      }
    });
  };
}

export function persistDatePickerUIValues() {
  return (dispatch) => {
    dispatch({
      type: PERSIST_DATEPICKERUI_VALUES
    });
  };
}

export function storeAppointmentDataValues(values) {
  return (dispatch) => {
    dispatch({
      type: STORE_APPOINTMENT_DATA_SUCCESS,
      payload: {
        ...values
      }
    });
  }
}

export function cleanAppointmentStore(props) {
  return (dispatch) => {
    dispatch({
      type: CLEAN_APPOINTMENT_STORE,
      payload: {
        props
      }
    });
  }
}

export function storeAddressFormValues(values) {
  return (dispatch) => {
    dispatch({
      type: STORE_ADDRESS_FORM_VALUES_SUCCESS,
      payload: {
        values,
      },
    });
  };
}

export function loadAppointmentData(data) {
  return (dispatch) => {
    dispatch()
  };
}

export function geolocateAddress(address) {
  return (dispatch) => {

    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => {
        dispatch({
          type: GEOLOCATE_ADDRESS_SUCCESS,
          payload: {
            latLng,
          }
        })
      })
      .catch(error => console.error('Error', error))
  }
}

export function setPickupAddress(address) {
  return (dispatch) => {
    dispatch({
      type: STORE_PICKUP_ADDRESS,
      payload: {
        pickupAddress: address
      }
    });
  }
}

export function setWorkshopLatLng(latLng) {
  return (dispatch) => {
    dispatch({
      type: STORE_WORKSHOP_LATLNG,
      payload: {
        latLng
      }
    });
  }
}

export function fetchAvailableAdvisors(date, time, budgetId, autocareEmailHash) {
  return (dispatch) => {
    fetchAvailableAdvisorsRequester(date, time, budgetId, autocareEmailHash)
      .then((response) => {
        dispatch({
          type: GET_ADVISORS_SUCCESS,
          payload: {
            advisors: response.data,
          }
        });
      })
      .catch(apiErrorHandler);
  }
}

export function setSelectedDateAndTime(date, time) {
  return (dispatch) =>
    dispatch({
      type: SET_SELECTED_DATE_AND_TIME,
      payload: {
        selectedDate: date,
        selectedTime: time
      }
    })
}

export function fetchAvailableHoursAdvisor(data) {
  return (dispatch) => {
    fetchAvailableHoursAdvisorRequester(data)
      .then((response) => {
        dispatch({
          type: GET_ADVISORS_HOURS_SUCCESS,
          payload: {
            hours: response.data,
          }
        });
      })
      .catch(apiErrorHandler);
  }
}

export function cleanAdvisorStore(props) {
  return (dispatch) => {
    dispatch({
      type: CLEAN_ADVISOR_STORE,
      payload: {
        props,
      }
    })
  }
}

export function fetchAvailableHours(date, autocare = '') {
  return (dispatch) => {
    fetchAvailableHoursRequester(date, autocare)
      .then((response) => {
        dispatch({
          type: GET_ADVISORS_HOURS_SUCCESS,
          payload: {
            hours: response.data,
          }
        });
      })
      .catch(apiErrorHandler);
  }
}

export function setBeforeBudget(beforeBudget) {
  return (dispatch) => {
    dispatch({
      type: SET_BEFORE_BUDGET,
      payload: {
        beforeBudget: beforeBudget,
      }
    });
  }
}

export function fetchEmptyDates(date, autocare) {
  return (dispatch) => {
    fetchEmptyDatesRequester(date, autocare)
      .then((response) => {
        dispatch({
          type: GET_EMPTY_DATES_SUCCESS,
          payload: {
            emptyDates: response.data,
          }
        });
      })
      .catch(apiErrorHandler);
  }
}


// WEBPACK FOOTER //
// ./src/workflow/checkout/appointment/actions.js